import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-expiring-soon-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './expiring-soon-chart.component.html',
  styleUrl: './expiring-soon-chart.component.scss'
})
export class ExpiringSoonChartComponent {
  @Input() isLoadingAboutToExpiry: boolean = false;
  @Input() aboutToExpiryData: any[] = [];
}
